import { ca } from '@cian/analytics';

interface ITrackContactListOpenParams {
  newbuildingId: number;
  gaLabel: string;
  placeType: string;
}

export function trackContactListOpen({ newbuildingId, gaLabel, placeType }: ITrackContactListOpenParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Open_contacts_chats',
    action: 'CardJK',
    label: gaLabel,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    page: {
      extra: {
        type: placeType,
      },
    },
  });
}
